import React from 'react'
import Contractdownloadform from '../../components/contractreportcomponents/Contractdownloadform'

function  Contractoutdownload({renderPageContent}) {
    return (
        <>
                        <Contractdownloadform renderPageContent={renderPageContent}/>
        </>
    )
}

export default  Contractoutdownload